/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateResourceRequest
 */
export interface UpdateResourceRequest {
    /**
     * RID of the resource
     * @type {string}
     * @memberof UpdateResourceRequest
     */
    rID: string;
    /**
     * Resource metadata
     * @type {object}
     * @memberof UpdateResourceRequest
     */
    state: object;
}

/**
 * Check if a given object implements the UpdateResourceRequest interface.
 */
export function instanceOfUpdateResourceRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rID" in value;
    isInstance = isInstance && "state" in value;

    return isInstance;
}

export function UpdateResourceRequestFromJSON(json: any): UpdateResourceRequest {
    return UpdateResourceRequestFromJSONTyped(json, false);
}

export function UpdateResourceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateResourceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': json['RID'],
        'state': json['state'],
    };
}

export function UpdateResourceRequestToJSON(value?: UpdateResourceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
        'state': value.state,
    };
}

